"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const joiful_1 = require("./joiful");
const validation_1 = require("./validation");
var validation_2 = require("./validation");
exports.Validator = validation_2.Validator;
exports.MultipleValidationError = validation_2.MultipleValidationError;
exports.isValidationPass = validation_2.isValidationPass;
exports.isValidationFail = validation_2.isValidationFail;
var joiful_2 = require("./joiful");
exports.Joiful = joiful_2.Joiful;
exports.DEFAULT_INSTANCE = new joiful_1.Joiful();
const DEFAULT_VALIDATOR = new validation_1.Validator();
const { validate, validateAsClass, validateArrayAsClass } = DEFAULT_VALIDATOR;
exports.validate = validate;
exports.validateAsClass = validateAsClass;
exports.validateArrayAsClass = validateArrayAsClass;
const { any, array, boolean, date, func, joi, link, number, object, string, validateParams, getSchema, hasSchema, } = exports.DEFAULT_INSTANCE;
exports.any = any;
exports.array = array;
exports.boolean = boolean;
exports.date = date;
exports.func = func;
exports.joi = joi;
exports.link = link;
exports.number = number;
exports.object = object;
exports.string = string;
exports.validateParams = validateParams;
exports.getSchema = getSchema;
exports.hasSchema = hasSchema;
//# sourceMappingURL=index.js.map